export * from './interfaces/register_location';
export * from './components/register-h2-location/register-h2-location.component';
export * from './components/register-h2-location/components/register-h2-years-form/register-h2-years-form.component';
export * from './components/register-h2-location/components/verteilnetzbetreiber/verteilnetzbetreiber.component';
export * from './components/register-co2-location/register-co2-location.component';
export * from './components/register-co2-location/components/register-co2-data-form/register-co2-data-form.component';
